import { computed, watch } from 'vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import isoWeek from 'dayjs/plugin/isoWeek'
import 'dayjs/locale/en'
import 'dayjs/locale/he'
import i18n from '@/i18n'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(weekOfYear)
dayjs.extend(quarterOfYear)
dayjs.extend(isoWeek)

export { dayjs }

export const dayjsLocales = {
    en: 'en',
    he: 'he',
} as const

export const dayjsLocale = computed(() => {
    const currentLocale = i18n.global.locale.value as keyof typeof dayjsLocales
    return dayjsLocales[currentLocale] || 'en'
})

watch(
    dayjsLocale,
    (newLocale) => {
        dayjs.locale(newLocale)
    },
    { immediate: true }
)
